import { isNil } from "lodash";
import {
  UseNumberInput,
  useNumberInput
} from "PFApp/booking/components/booking_form/requirement_selector/use_number_input";
import React from "react";

import { useBookingRowsContext } from "../../../../../context/booking_rows_context";
import css from "./item_content.module.scss";

type InputProps = UseNumberInput & {
  disabled: boolean;
};

export const Input = ({ disabled, ...numberInputProps }: InputProps) => {
  const { value, handleChange } = useNumberInput(numberInputProps);
  const { wallPlannerEditMode } = useBookingRowsContext();

  const handleBlur = () => {
    if (isNil(value) || value === "" || Number(value) === numberInputProps.defaultValue) {
      return;
    }
    wallPlannerEditMode.setLoading(true);
  };

  return (
    <input
      value={value}
      onChange={({ target: { value } }) => handleChange(value)}
      className={css.input}
      disabled={disabled}
      onBlur={handleBlur}
    />
  );
};
